<nz-page-header title="Регистрация"/>
@if (!success) {
  <section class="mb-5 container-lg">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-xl-6">
        <div class="px-3 border rounded-3 shadow bg-light">
          <header class="py-4 mb-4 border-bottom d-flex align-items-center gap-3">
            <nz-logo height="50"/>
            <h1 class="text-muted">Collectoria</h1>
          </header>
          <main>
            <form [formGroup]="form">
              <fieldset class="mb-4">
                <label for="username" class="mb-0 form-label">Потребителско име*</label>
                <button
                  type="button"
                  (click)="showUsernameInfo()"
                  class="btn btn-link text-dark p-0">
                  <i class="mx-1 text-primary-emphasis fa-regular fa-circle-question" aria-hidden="true"></i>
                </button>
                <input
                  id="username"
                  type="text"
                  formControlName="username"
                  class="form-control"
                  placeholder="Въведете потребителско име..."
                  aria-label="Потребителско име"
                  [class.is-valid]="username?.touched && username?.valid"
                  [class.is-invalid]="username?.touched && username?.invalid">
                <p class="invalid-feedback m-0">Задължително поле!</p>
              </fieldset>
              <fieldset class="mb-4">
                <label for="email" class="mb-0 form-label">Електронна поща*</label>
                <input
                  id="email"
                  type="text"
                  formControlName="email"
                  class="form-control"
                  placeholder="Въведете Вашия имейл..."
                  aria-label="Електронна поща"
                  [class.is-valid]="email?.touched && email?.valid"
                  [class.is-invalid]="email?.touched && email?.invalid">
                <p class="invalid-feedback m-0">Задължително поле!</p>
              </fieldset>
              <fieldset class="mb-4">
                <label for="password" class="mb-0 form-label">Парола*</label>
                <input
                  id="password"
                  type="password"
                  minlength="8"
                  formControlName="password"
                  class="form-control"
                  placeholder="Въведете парола..."
                  aria-label="Парола"
                  [class.is-valid]="password?.touched && password?.valid"
                  [class.is-invalid]="password?.touched && password?.invalid">
                <p class="invalid-feedback m-0">Задължително поле с минимална дължина от 8 символа!</p>
              </fieldset>
              <fieldset class="mb-4">
                <label for="confirmPassword" class="mb-0 form-label">Повторете паролата*</label>
                <input
                  id="confirmPassword"
                  type="password"
                  minlength="8"
                  formControlName="confirmPassword"
                  class="form-control"
                  placeholder="Повторете паролата..."
                  aria-label="Повторете паролата"
                  [class.is-valid]="confirmPassword?.touched && confirmPassword?.valid && confirmPassword?.value === password?.value"
                  [class.is-invalid]="confirmPassword?.touched && (confirmPassword?.invalid || confirmPassword?.value !== password?.value)">
                @if (confirmPassword?.touched && !confirmPassword?.valid) {
                  <div class="text-danger">
                    <small>Задължително поле с минимална дължина от 8 символа!</small>
                  </div>
                }
                @if (confirmPassword?.touched && confirmPassword?.value !== password?.value) {
                  <div class="text-danger">
                    <small>Паролата не съвпада!</small>
                  </div>
                }
              </fieldset>
              <fieldset class="mb-4">
                <label for="firstName" class="mb-0 form-label">Име*</label>
                <input
                  id="firstName"
                  type="text"
                  minlength="2"
                  maxlength="50"
                  formControlName="firstName"
                  class="form-control"
                  placeholder="Въветете Вашето име..."
                  aria-label="Име"
                  [class.is-valid]="firstName?.touched && firstName?.valid"
                  [class.is-invalid]="firstName?.touched && firstName?.invalid">
                <p class="invalid-feedback m-0">Задължително поле (от 2 до 50 символа)!</p>
              </fieldset>
              <fieldset class="mb-4">
                <label for="lastName" class="mb-0 form-label">Фамилия*</label>
                <input
                  id="lastName"
                  type="text"
                  minlength="2"
                  maxlength="50"
                  formControlName="lastName"
                  class="form-control"
                  placeholder="Въветете Вашата фамилия..."
                  [class.is-valid]="lastName?.touched && lastName?.valid"
                  [class.is-invalid]="lastName?.touched && lastName?.invalid">
                <p class="invalid-feedback m-0">Задължително поле (от 2 до 50 символа)!</p>
              </fieldset>
              <fieldset class="mb-4">
                <div class="d-flex align-items-start">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="isConfirmTermsConditions"
                    formControlName="isConfirmTermsConditions">
                  <p class="invalid-feedback m-0">Задължително поле (от 2 до 50 символа)!</p>
                  <label for="isConfirmTermsConditions" class="mx-2 form-check-label">
                    Декларирам, че съм запознат и приемам
                    <a class="text-decoration-none"
                       aria-label="Общи условия на сайта"
                       [routerLink]="[appRoutes.root, appRoutes.termsConditions]">
                      общите условия на сайта.
                    </a>
                  </label>
                </div>
                @if (isConfirmTermsConditions?.touched && !isConfirmTermsConditions?.value) {
                  <div class="text-danger">
                    <small>Трябва да се запознаете и да приемете общите условия!</small>
                  </div>
                }
              </fieldset>
            </form>
            @if (!!errorMessage) {
              <div class="pb-4 text-danger">
                {{ errorMessage }}
              </div>
            }
            <button
              (click)="onSubmit()"
              [disabled]="loading"
              class="w-100 mb-4 btn btn-nz-primary">
              @if (loading) {
                <span class="me-2 spinner-border spinner-border-sm"></span>
              }
              <span>Регистрация</span>
            </button>
          </main>
          <footer class="mb-3 pt-3 d-flex justify-content-between border-top">
            <a aria-label="Вход"
               class="btn btn-link text-decoration-none"
               [routerLink]="[appRoutes.root, appRoutes.account, appRoutes.login]">
              Вход
            </a>
            <a aria-label="Забравена парола"
               class="btn btn-link text-decoration-none"
               [routerLink]="[appRoutes.root, appRoutes.account, appRoutes.passwordRecovery]">
              Забравена парола
            </a>
          </footer>
        </div>
      </div>
    </div>
  </section>
} @else {
  <div class="mb-5 container-lg">
    <div class="alert alert-primary rounded-3 shadow">
      <h5>Успешна регистрация!</h5>
      <div class="pb-2">
        Имейл с инструкции за активация беше изпратен до <strong>{{ email?.value }}</strong>.
      </div>
      <div>
        Ако не виждате имейла в основната си поща, моля проверете в папка "Спам" или "Нежелана поща". Ако все още не
        откривате имейла, не се колебайте да се свържете с нашия екип за съдействие.
      </div>
    </div>
  </div>
}
